import {
  API_RESULT,
  BusinessUnit,
  COLLECT_CARD_INSTRUCTION,
  DIGITAL_AGENT_BUTTONS,
  PolictSupplier,
  RecordingState,
  URL_SOURCE_TYPE,
  UserPlatform,
} from "./enums";

export type GetReq = {
  fullUrl?: string;
  url?: string;
  loading?: boolean;
  isRefreshed?: boolean;
  hideLoader?: boolean;
};

export type PostReq = GetReq & {
  body?: Object;
};
export type POPUP_CONTENT = {
  show: boolean;
  type: string;
  image?: object;
  title: string;
  subTitle?: string;
  okBtnText?: string;
  cancelBtnText?: string;
  okBtnAction?: number;
  cancelBtnAction?: number;
  props?: any;
  img?: string;
  mobileImg?: string;
  body?: string;
  withButton?: boolean;
  strings?: object;
  hideCloseBtn?: boolean;
  bodyList?: MustListBodyList[];
  errorStatus?: number;
  withBuyPolicyBtn?: boolean;
  buyPolicyBtnText?: string;
};

export type CASE_DATA_REQUEST = {
  email: string;
  issue: string;
  reason: string;
  details: string;
  id_number: string;
};
export type Tokens = {
  xSessionId: string;
};
export type Headers = {
  Accept: string;
  "Content-Type": string;
  Authorization: string;
};
export type USER_INFO = {
  email: string;
  address: string;
  zip: string;
  city: string;
  apartment: string;
};

export type DropDown = {
  id: string;
  name: string;
};
export type TranslationsResponse = {
  responseMessage: string;
  responseCode: string;
  responseData: {
    strings: any;
  };
};
export type ResponseError = {
  responseCode: string;
  responseMessage: string;
  error: ErrMessage;
};
export type ErrMessage = {
  message: string;
};
export enum CREDIT_CARD_BRAND {
  MASTERCARD = "1",
  VISA = "2",
}

export type CreditCard = {
  feCC4LastDigits: string;
  feCustCCExpirationDate: string;
  feCCCardBrand: CREDIT_CARD_BRAND;
  feCCcardMask: string;
  feCustCCStatus: string;
  index: number;
  feCCToken: string;
};

export type CustomerCreditCardResponse = {
  existingCustomer: boolean;
  creditCards: CreditCard[];
};
export enum CreditCardStatus {
  ACTIVE = "active",
  INACTIVE = "notActive",
}

export type PersonalDetails = {
  feCustFirstNameHeb: string;
  feCustLastNameHeb: string;
  feCustFirstNameEng: string;
  feCustLastNameEng: string;
  feCustCountryPhoneCode: string;
  feCustAreaCode: string;
  feCustPhone: string;
  feCustEmail: string;
  feCustGender: "male" | "female";
  feCustStreet: string;
  feCustCity: string;
  feCustCityName: string;
  feCustStreetName: string;
  feCustPostalCode: string;
  fePFSmarketingMailing: boolean;
  feServiceConditionConfirmation: boolean;
  feHouseNumber: number;
  feCustHouseNumber: number;
};

export type ResponseFxStatus = {
  message: string;
  code: string;
};

type PolicyDto = {
  travelPolicyNumberField: number;
  policyStartDateField: string;
  policyEndDateField: string;
  saleRepresentetiveIDField: number;
  isAnnualField: boolean;
  createdByField: number;
  policyPurchaseDateField: string;
  saleRepresentativeNameField: string;
  saleRepresentetiveIdField: number;
  taxRefundSupplierField: PolictSupplier | null;
};

type LeadDetailsDto = {
  agentIDField: number;
  agentNameField: string;
  leadIDField: number;
  leadNoteField: string;
  numberOfPassangersField: number;
};

export type CountryOfDestinationDto = {
  countryField: string;
  countryISOField: string;
};

export type PolicyDetails = {
  policyDtoField: PolicyDto;
  leadDetailsDtoField: LeadDetailsDto;
  countryOfDestinationDtoField: CountryOfDestinationDto[];
};
export type PolicyDetailsUpdate = {
  feLeadNote: string;
  fePolicyEndDate: string;
  fePolicyDestinationISO: string[];
  fePolicyPurchaseDate: string;
  feAgentName: string;
  feCreatedBy: number;
  fePolicyId: string;
  fePolicyDestination: string[];
  fePolicyStartDate: string;
  fePolicyNumOfPassangers: number;
  fePolicyAgentId: string;
  feCollectCardInstructions: number;
  feSaleRepresentetiveId: number;
  feSaleRepresentetiveName: string;
};

export type UpdatePolicyRequest = {
  feVIPTypeID: string;
  feIsMarkedAsTesting: boolean;
  fePolicyDetails: PolicyDetailsUpdate;
  feCustPersId: string;
  feVIPCode: string;
  feSendAdsByEmailBy3rdParty: boolean;
  feBU: string;
};

export type CheckFxEligibilityResponse = {
  responseStatus: ResponseFxStatus;
  responseData: ResponseFxData;
};
export type CheckOrCreateOtpResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdatePolicyResponse = {
  responseMessage: string;
  responseCode: string;
};
export type GeneralErrorResponse = {
  data: { responseStatus: ResponseFxStatus; responseData: ResponseFxData };
  error: Boolean;
  status: number;
};
export type GetCCInfoError = {
  data: {
    feCustTravelPolicyNumber: string;
    feCustPersonalId: string;
    feBU: string;
    error: {
      message: string;
    };
  };
};
export type CheckOrCreateOtpError = {
  error: boolean;
  status: number;
  data: {
    responseCode: number;
    responseMessage: string;
    error: {
      message: string;
    };
  };
};

export type CheckFxEligibilityRequest = {
  channel: number;
  personalId: string;
  salesExperimentVersionID?: string;
  versionName?: string;
  experimentType?: string;
  areaCode?: string;
  phone?: string;
  countryPhoneCode?: string;
  thirdPartyApproval?: string;
  guid?: string;
  businessUnit?: string | null;
  travelPolicyNumber?: string | null;
  agentId?: string | null;
  salesExperimentID?: string | null;
  experimentName?: string | null;
  feCampaignId?: string | null;
  feCampaignName?: string | null;
  userId?: string | null;
};
export enum PAYMENT_METHOD_INDICATION {
  GENERAL_ERROR = 4,
  CARD_BRAND_NOT_AUTHORIZED = 1,
  CARD_WILL_EXPIRE = 2,
  PERSONAL_ID_MISMATCH = 3,
  NOT_ISRAELI_CARD = 5,
  DEBIT_CARD = 6,
  NOT_ISRAELI_AND_DEBIT_CARD = 7,
  ACTIVE_CARD = 8,
  NOT_ACTIVE_CARD = 9,
}

export type ResponseFxData = {
  needToUpdatePhone: boolean;
  personalId: string;
  visaMaxWalletLimit: number;
  visaLimitationMessageEnabled: boolean;
  last4PhoneDigits: string;
  paymentMethodIndication: PAYMENT_METHOD_INDICATION;
  policyDetails: PolicyDetails[];
  collectCardInstruction: COLLECT_CARD_INSTRUCTION;
  responseMessage: string;
  passportCard4LastDigits: string;
  responseCode: number;
  isRiskCountry: boolean;
  sharedLink: string;
  leadButton: boolean;
  sessionId: string;
  enableSms: boolean;
  enableImmediateOnboard: boolean;
};

export type City = {
  name: string;
  id: string | number;
};
export type ChoosePolicyProps = {
  checkboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setChoosenPolicyItem: (policy: any) => void;
};

export type PolicyItemType = {
  index: number;
  passengers: string;
  dates: string;
  destination: string;
};
export type TextElements = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";

export type MustListBodyList = {
  title: string;
  ariaLabel: string;
};
export type ServiceIncludesList = {
  image: string;
  imageWidth?: number;
  imageHeight?: number;
  title: string;
  subTitle: string;
  options?: string[];
};

export type StreetsResponse = {
  responseCode: string;
  streets: Street[];
};

export type Street = {
  streetId: number;
  streetName: string;
};
export type ZipCodeResponse = {
  zipCode: string;
};
export type UpdateContactDetailsResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdateZipCodeResponse = {
  responseMessage: string;
  responseCode: string;
};
export type PostMessageData = {
  errorMessage?: string;
  responseCode?: string;
  status?: API_RESULT;
  buttonClicked?: DIGITAL_AGENT_BUTTONS;
  collectCardInstruction?: COLLECT_CARD_INSTRUCTION;
  passportCard4LastDigits?: string;
  errorCode?: number;
  pathname?: string;
};
export type CreateOrUpdateUserRequest = {
  feServiceConditionConfirmation?: boolean;
  feCustPersId: string;
  feCustTravelPolicyNumber: string;
  feOperationModel: number;
  feBU: string;
  feChannel: number;
};
export type CreateOrUpdateUserResponse = {
  responseMessage: string;
  responseCode: string;
};

export type GetTaxRefundInfoRequest = {
  feCustTravalPolicyNumber: string;
  feGuid: string;
  feCustPersId: string;
  feBU: string;
};
export type GetTaxRefundInfoResponse = {
  data: TaxRefundInfo;
  responseMessage: string;
  responseCode: string;
};
export type TaxRefundInfo = {
  feCustPassportNumber: string;
  feCustLastNameEnglish: string;
  feCustPassportNationality: string;
  feCustIssuingCountry: string;
  feCustPassportValidity: string;
  fe3rdPartyTaxRefund: boolean;
  feCustaxRefundEligibility: boolean;
  feCustFirstNameEnglish: string;
  feCustTaxRefundRegistration: boolean;
};

export type GetCountriesResponse = {
  countries: string[];
};
export type CreateTaxRefundMemberRequest = {
  feCustPassportNum: string;
  feIssuingCountry: string;
  feCustLastNameEnglish: string;
  feCustPassportNationality: string;
  feCustPersId: string;
  feCustPassportValidity: string;
  feBU: string;
  feCustFirstNameEnglish: string;
};
export type CreateTaxRefundMemberResponse = {
  responseMessage: string;
  responseCode: string;
};
export type SendLeadOrSmsResponse = {
  responseMessage: string;
  responseCode: string;
};
export type UpdateCCInfoResponse = {
  creditCards: {
    feCC4LastDigits: string;
    feCustCCExpirationDate: string;
    feCustCCStatus: string;
    feCCCardBrand: string;
    feCCcardMask: string;
  }[];
};
export type StartOnboardingEnsureResponse = {
  responseMessage: string;
  responseCode: string;
};
export type PausedActiveRecordingResponse = {
  responseMessage: string;
  responseCode: string;
};

export enum TAX_REFUND_CONDITION {
  ELIGIBLE_NOT_REGISTERED = "ELIGIBLE_NOT_REGISTERED",
  ELIGIBLE_AND_REGISTERED = "ELIGIBLE_AND_REGISTERED",
  REGISTERED_NOT_ELIGIBLE = "REGISTERED_NOT_ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
}
export interface TaxRefundStatus {
  isRegistered: boolean;
  isEligible: boolean;
}
export const AUTH_REQUIRED_SOURCES = [
  URL_SOURCE_TYPE.SMS,
  URL_SOURCE_TYPE.CAMPAIGN,
  URL_SOURCE_TYPE.MARKETING,
  URL_SOURCE_TYPE.SMS_SHARE,
];
export const OTHER_SOURCES = [
  URL_SOURCE_TYPE.PFS_REP,
  URL_SOURCE_TYPE.REP_MANUAL,
  URL_SOURCE_TYPE.ENSURE,
];

export type CustomInputType = "id" | "phone" | "otp";

export type GetCitiesResponse = {
  cities: CityResponse[];
};
export type CityResponse = {
  city_id: string;
  name_hebrew: string;
  name_english: string;
};
export type StreetAndCityResponse = {
  street_id: string;
  name_hebrew: string;
  name_english: string;
  city_id: string;
};
export interface UpdateOnboardingAnalytics {
  fePfsSessionId: string;
  feCustPerslId?: string;
  feCustTravelPolicyNumber: string;
  feBu: BusinessUnit;
  feChannel: number;
  feUserPlatform: UserPlatform;
  feCreatedBy?: number;
  timeout?: boolean;
  abandon?: boolean;
  login_details?: boolean;
  login_otp?: boolean;
  login_choose_policy?: boolean;
  pc_plus?: boolean;
  ensure_agent_options?: boolean;
  update_contact_details?: boolean;
  activate_credit_card?: boolean;
  activate_credit_card_iframe?: boolean;
  activate_credit_card_qa?: boolean;
  must_list?: boolean;
  summary?: boolean;
  summary_global_blue?: boolean;
  summary_global_blue_qa?: boolean;
  summary_card_use_qa?: boolean;
  error_popup?: boolean;
  error_popup_code?: string;
  error_popup_desc?: string;
  campaign_id?: string;
  campaign_name?: string;
  campaign_source?: string;
  campaign_medium?: string;
  campaign_term?: string;
  campaign_content?: string;
  experiment_name?: string;
  experiment_type?: string;
  sales_experiment_id?: string;
  sales_experiment_version_id?: string;
  version_name?: string;
}
export type ExperimentData = {
  salesExperimentID: string;
  experimentName: string;
  salesExperimentVersionID: string;
  versionName: string;
  experimentType: string;
};
export type ErrorResponse = {
  responseStatus: {
    message: string;
    code: string;
  };
  responseData: {
    responseMessage: string;
    responseCode: string;
  };
};
export enum ResponseMessages {
  OTP_INVALID = "Invalid OTP",
  USER_BLOCKED = "User blocked",
}
export type InquiryGCIframeResultsError = {
  error: boolean;
  status: number;
  data: {
    responseCode: number;
    message: string;
    error: {
      message: string;
    };
  };
};
export type PausedActiveRecordingRequest = {
  feRecordingState: RecordingState;
  feAgentAD: string;
};
